export default function CheckboxIndeterminateIcon({
  width = 24,
  height = 24,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <rect width='12' height='12' rx='2' fill='currentColor' />
      <path d='M3.42871 6H8.57157' stroke='white' strokeWidth='1.30599' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
